/* eslint-disable react-hooks/exhaustive-deps */
import { ApButtonSecondary } from '@alixpartners/ui-components';
import BreakDownFilters from 'SpendController/Components/BreakDownFilters/BreakDownFilters';
import {
	ColumnContainer,
	Container,
	GridContainer,
	GridItem,
	Header,
	HeaderSpan,
	RefreshSpan,
	TableFilterHeader,
} from 'SpendController/Components/Components.styles';
import LoadingSpinner from 'SpendController/Components/LoadingSpinner/LoadingSpinner';
import Summary from 'SpendController/Components/Summary/Summary';
import TableView from 'SpendController/Components/TableView';
import { TableWrapper } from 'SpendController/Components/TableView/TableView.style';
import { useSpendControllerFiltersContext } from 'SpendController/Contexts/SpendControllerFiltersProvider';
import {
	GL_HEADER,
	GL_REFRESH_HEADER,
	extractSelectedArrays,
	SAVINGS_SIGNS_OFF_KPI_DATA,
	PENDING_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE,
	updateSavingsData,
	keyMapping,
} from 'SpendController/utils';
import React, { useEffect, useState } from 'react';
import { getSavingSignOffSummaryKpis } from 'utils/apiRequests';

const healthBars = [`Signed Off Savings`, `Pending Signed Off`, `Lost Savings`];

function SavingsSignOff() {
	const [savingsSignoffKpiData, setSavingsSignoffKpiData] = useState(
		SAVINGS_SIGNS_OFF_KPI_DATA
	);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedKPI, setSelectedKPI] = useState(0);
	const [reFresh, setrefresh] = useState(false);
	const [gridApi, setGridApi] = useState(null);

	const selectedSpendType = ['MACRO'];
	const {
		filters,
		savingsSignOffColumnDefs,
		filterModelData,
		refresh,
		setRefresh,
		uploadRefresh,
		handleSpendControllerFilters,
		setSpendType,
		setUploadRefresh,
	} = useSpendControllerFiltersContext();
	useEffect(
		() => {
			handleKpiData(filters, true);
		},
		[filters]
	);
	useEffect(
		() => {
			refresh && handleKpiData(filters);
		},
		[refresh]
	);
	useEffect(
		() => {
			uploadRefresh &&
				(() => {
					handleSpendControllerFilters();
					handleKpiData(filters);
				})();
		},
		[uploadRefresh]
	);
	useEffect(() => {
		setSpendType(selectedSpendType);
	}, []);
	const handleKpiData = async (filters, realTime = false) => {
		const tempFilters = extractSelectedArrays(filters);
		const microFilters = Object.assign({}, tempFilters);
		microFilters.tailSpendType = ['MACRO'];
		realTime && setIsLoading(true);
		const savingsSignoffKpiDataResponse = await getSavingSignOffSummaryKpis(
			microFilters
		);
		const tempPreWorkShopBaselineKpiData = updateSavingsData(
			savingsSignoffKpiDataResponse,
			savingsSignoffKpiData.data,
			keyMapping
		);
		setSavingsSignoffKpiData({
			...savingsSignoffKpiData,
			data: tempPreWorkShopBaselineKpiData,
		});
		realTime && setIsLoading(false);
		setRefresh(false);
	};
	const handleClick = index => {
		setSelectedKPI(index);
	};
	return (
		<Container>
			<LoadingSpinner visible={isLoading} message={`Loading`} />

			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<GridContainer>
					{healthBars.map((name, index) => (
						<GridItem
							key={index}
							selected={selectedKPI === index}
							onClick={() => handleClick(index)}
						>
							{name}
						</GridItem>
					))}
				</GridContainer>
				<ApButtonSecondary
					onClick={() => {
						setUploadRefresh(state => !state);
						setrefresh(state => !state);
					}}
					small
					style={{ margin: '1%' }}
				>
					Refresh/Save
				</ApButtonSecondary>
			</div>
			{selectedKPI === 0 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary
						{...savingsSignoffKpiData}
						data={[
							savingsSignoffKpiData.data[0],
							savingsSignoffKpiData.data[1],
						]}
						columns={6}
						rows={1}
					/>
				</div>
			)}
			{selectedKPI === 1 && (
				<div style={{ padding: '0px 0 0 10px' }}>
					<Summary
						{...savingsSignoffKpiData}
						data={[
							savingsSignoffKpiData.data[2],
							savingsSignoffKpiData.data[3],
						]}
						columns={6}
						rows={1}
						title={PENDING_SAVINGS_SIGNS_OFFS_SUMMARY_TITLE}
						// Fcolor={`#a4a4a6`}
					/>
				</div>
			)}
			{selectedKPI === 2 && (
				<div style={{ display: 'flex', padding: '0px 0 0 10px' }}>
					<Summary
						{...savingsSignoffKpiData}
						data={[
							savingsSignoffKpiData.data[4],
							savingsSignoffKpiData.data[5],
						]}
					/>
				</div>
			)}

			<ColumnContainer>
				<Header>
					<RefreshSpan>{GL_REFRESH_HEADER}</RefreshSpan>
				</Header>
				<TableFilterHeader>
					<HeaderSpan>{GL_HEADER}</HeaderSpan>
					<BreakDownFilters gridApi={gridApi} />
				</TableFilterHeader>
				<TableWrapper n={7}>
					<TableView
						data={savingsSignOffColumnDefs}
						columnDefs={savingsSignOffColumnDefs.headers}
						filters={filterModelData}
						mainfilters={filters}
						handleCall={handleKpiData}
						selectedSpendType={selectedSpendType}
						refresh={reFresh}
						gridApi={gridApi}
						setGridApi={setGridApi}
					/>
				</TableWrapper>
			</ColumnContainer>
		</Container>
	);
}

export default SavingsSignOff;
